// extracted by mini-css-extract-plugin
export default {"container":"policy_container__TzQkg","list":"policy_list__rXRpG"};